module.exports = __webpack_public_path__ + "static/img/noData.199076b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/noData.png
// module id = cABt
// module chunks = 110